import Service from "../../services";

const FormRO = {
    namespaced: true,
    state: {
        formResearch: 1,
        researchID: '',
    },
    mutations: {
        SET_PAGE: (state, page) => {
            state.formResearch = page;
        },
        SET_RESEARCH_ID: (state, res) => {
            state.researchID = res.researchID;
        },
    },
    actions: {
        saveRO02({ commit }, data) {
            return Service.FormRO.saveRO02(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveRO03_1({ commit }, data) {
            return Service.FormRO.saveRO03_1(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveRO04_1({ commit }, data) {
            return Service.FormRO.saveRO04_1(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveRO04_2({ commit }, data) {
            return Service.FormRO.saveRO04_2(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveRO05({ commit }, data) {
            return Service.FormRO.saveRO05(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveDraftRO05({ commit }, data) {
            return Service.FormRO.saveDraftRO05(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveRO06_1({ commit }, data) {
            return Service.FormRO.saveRO06_1(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveDraftRO06_1({ commit }, data) {
            return Service.FormRO.saveDraftRO06_1(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveRO07_1({ commit }, data) {
            return Service.FormRO.saveRO07_1(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveDraftRO07_1({ commit }, data) {
            return Service.FormRO.saveDraftRO07_1(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveRO08({ commit }, data) {
            return Service.FormRO.saveRO08(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveDraftRO08({ commit }, data) {
            return Service.FormRO.saveDraftRO08(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveRO09({ commit }, data) {
            return Service.FormRO.saveRO09(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveDraftRO09({ commit }, data) {
            return Service.FormRO.saveDraftRO09(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveRO10({ commit }, data) {
            return Service.FormRO.saveRO10(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveDraftRO10({ commit }, data) {
            return Service.FormRO.saveDraftRO10(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveRO19({ commit }, data) {
            return Service.FormRO.saveRO19(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveDraftRO19({ commit }, data) {
            return Service.FormRO.saveDraftRO19(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getROSusar({ commit }, data) {
            return Service.FormRO.getROSusar(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRO02({ commit }, data) {
            return Service.FormRO.getRO02(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRO03_1({ commit }, data) {
            return Service.FormRO.getRO03_1(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRO04_1({ commit }, data) {
            return Service.FormRO.getRO04_1(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRO04_2({ commit }, data) {
            return Service.FormRO.getRO04_2(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRO05({ commit }, data) {
            return Service.FormRO.getRO05(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRO06_1({ commit }, data) {
            return Service.FormRO.getRO06_1(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRO07_1({ commit }, data) {
            return Service.FormRO.getRO07_1(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRO08({ commit }, data) {
            return Service.FormRO.getRO08(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRO09({ commit }, data) {
            return Service.FormRO.getRO09(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRO10({ commit }, data) {
            return Service.FormRO.getRO10(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRO19({ commit }, data) {
            return Service.FormRO.getRO19(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveROSusar({ commit }, data) {
            return Service.FormRO.saveROSusar(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveDraftROSusar({ commit }, data) {
            return Service.FormRO.saveDraftROSusar(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },

    }
}

export default FormRO;
